import { useStateMachine } from "little-state-machine"
import { useIntl } from "react-intl"
import { updateAction } from "utils/littleStateMachine"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import InputTextArea from "components/InputMUI/TextArea"
import { GENERIC_MSGS } from "modules/claims/constants"
import { BUTTON_MESSAGES } from "utils/buttons"
import ProgressBar from "modules/claims/components/StepForm/ProgressBar"
import Select from "components/InputMUI/Select"
import { VISUAL_DEFECTS_SCHEMA, TYPE_VISUAL_DEFECT_OPTIONS, VISUAL_DEFECTS_MSGS } from "./constants"
import { useNavigate } from "react-router-dom"
import { redirectToNextStep } from "../../../utils"

const VisualDefects = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const { actions, state } = useStateMachine({ updateAction })

  const defaultValues = { ...state }
  const schema = yup.object(VISUAL_DEFECTS_SCHEMA(intl))

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema)
  })

  const onSubmit = (data) => {
    actions.updateAction(data)
    redirectToNextStep(navigate)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Select
        name="typeVisualDifference"
        control={control}
        label={VISUAL_DEFECTS_MSGS.typeVisualDifference}
        placeholder={GENERIC_MSGS.choose_placeholder}
        options={TYPE_VISUAL_DEFECT_OPTIONS}
        defaultValue={state.typeVisualDifference}
        error={errors.typeVisualDifference?.message}
      />
      <InputTextArea
        name="visualDefectsHowDetectDifference"
        control={control}
        label={VISUAL_DEFECTS_MSGS.howDetectsDifference}
        placeholder={GENERIC_MSGS.typeAnswer_placeholder}
        defaultValue={state.visualDefectsHowDetectDifference}
        error={errors.visualDefectsHowDetectDifference?.message}
      />
      <InputTextArea
        name="howCompareMaterial"
        control={control}
        label={VISUAL_DEFECTS_MSGS.howCompareMaterial}
        placeholder={GENERIC_MSGS.typeAnswer_placeholder}
        defaultValue={state.howCompareMaterial}
        error={errors.howCompareMaterial?.message}
      />
      <div className="btn-container">
        <button className="btn btn-dark" type="submit">
          {intl.formatMessage(BUTTON_MESSAGES.ok)}
        </button>
      </div>
      <ProgressBar
        progress={60}
        handleNext={handleSubmit(onSubmit)}
        RoutePrev={state.previousStep}
      />
    </form>
  )
}

export default VisualDefects
